import {
  ArrowRight,
  ArrowUpRight,
  Check,
  Monitor,
  Terminal,
  Apple,
  Play,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from '../i18n/Link'
import ProductPreview from './ProductPreview'
export default function Hero() {
  const { t } = useTranslation('home')
  const showDemo = () => {
    const preview = document.getElementById('product-preview')
    preview?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'instant'
        : 'smooth',
      block: 'center',
    })
    preview?.focus({ preventScroll: true })
  }
  return (
    <section className="premium-hero">
      <div className="hero-layout page-width">
        <div className="hero-copy">
          <Link to="/changelog" className="release-pill">
            <span>{t('hero.pillTag')}</span> {t('hero.pillText')}{' '}
            <ArrowUpRight size={13} />
          </Link>
          <div className="eyebrow">{t('hero.eyebrow')}</div>
          <h1>
            {t('hero.title1')} <br />
            {t('hero.title2')}
            <br />
            {t('hero.title3')} <span>{t('hero.titleAccent')}</span>
          </h1>
          <p>
            {t('hero.desc1')}
            <br className="desktop-break" /> {t('hero.desc2')}
            <br className="desktop-break" /> {t('hero.desc3')}
          </p>
          <div className="hero-buttons">
            <Link to="/download" className="jade-button">
              {t('hero.startFree')} <ArrowUpRight size={19} />
            </Link>
            <button className="outline-button" onClick={showDemo}>
              <Play size={15} /> {t('hero.explore')}
            </button>
          </div>
          <div className="hero-checks">
            <span>
              <Check size={14} /> {t('hero.easySetup')}
            </span>
            <span>
              <Check size={14} /> {t('hero.noCreditCard')}
            </span>
          </div>
          <div className="platforms">
            <span>{t('hero.platformsLead')}</span>
            <div>
              <Monitor size={17} /> Windows
              <i /> <Apple size={17} /> macOS
              <i />
              <Terminal size={17} /> Linux
              <Link to="/download" aria-label={t('hero.allPlatforms')}>
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
        <ProductPreview />
      </div>
      <div className="hero-bottom page-width">
        <span>{t('hero.bottomLead')}</span>
        <div>
          <span>
            <Monitor size={16} /> {t('hero.remoteDesktop')}
          </span>
          <span>
            <Terminal size={16} /> {t('hero.sshManagement')}
          </span>
          <span>
            <Check size={16} /> {t('hero.bulkDeploy')}
          </span>
        </div>
        <span className="edition">{t('hero.edition')}</span>
      </div>
    </section>
  )
}
